<script>
  import loader from '@monaco-editor/loader';
  import language from './sql';
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()
  let ed;
  let isParam = false;

  export let label;
  export let name;
  export let query;
  export let id = 'sqleditor';

  export let params = [];

  loader.init().then((monaco) => {
    function createDependencyProposals(sugs) {
      if (!isParam) {
        return sugs;
      } else {
        return params.map((param) => {
          return {
            label: param,
            kind: monaco.languages.CompletionItemKind.Function,
            insertText: `${param}}}`,
          };
        });
      }
    }
    monaco.languages.register({ id: 'sql1' });

    monaco.languages.setMonarchTokensProvider('sql1', language);
    const sugsArr = [
      ...language.keywords,
      ...language.operators,
      ...language.builtinFunctions,
    ];
    monaco.languages.registerCompletionItemProvider('sql1', {
      provideCompletionItems: function (model, position) {
        const sugs = sugsArr.map((sug) => {
          return {
            label: sug,
            kind: monaco.languages.CompletionItemKind.Property,
            insertText: sug.toUpperCase(),
          };
        });
        return {
          suggestions: createDependencyProposals(sugs),
        };
      },
      triggerCharacters: '{{',
    });
    monaco.editor.defineTheme('myCustomTheme', {
      base: 'vs',
      inherit: false,
      rules: [
        { token: 'keyword.sql', foreground: 'F78907', fontStyle: 'bold' },
        { token: 'operator.sql', foreground: 'F78907', fontStyle: 'bold' },
        { token: 'params', foreground: '894a00', fontStyle: 'bold' },
        { token: 'builtinFunctions.sql', foreground: 'F78907', fontStyle: 'bold' },
      ],
      colors: {
        'editor.foreground': '#000000',
      },
    });
    ed = monaco.editor.create(document.querySelector(`#${id}`), {
      value: query,
      language: 'sql1',
      theme: 'myCustomTheme',
      lineNumbers: 'off',
      minimap: {
        enabled: false
      },
      automaticLayout: true,
      renderLineHighlight: "none",
      overviewRulerBorder: false,
      hideCursorInOverviewRuler: true,
      overviewRulerLanes: 0
    });

    ed.getModel().onDidChangeContent((event) => {
      var pos = ed.getModel().getPositionAt(event.changes[0].rangeOffset);
      var range = {
        startLineNumber: pos.lineNumber,
        startColumn: pos.column - 1,
        endLineNumber: pos.lineNumber,
        endColumn: pos.column + 1,
      };
      var word = ed.getModel().getValueInRange(range);
      query = ed ? ed?.getValue() : ''
      dispatch('querying', query)
      if (word === '{{') {
        isParam = true;
      } else {
        isParam = false;
      }
    });
   
    
  });

</script>

<div class="w-full">
  <label
    for={name}
    class="justify-self-end block text-sm font-medium text-gray-700 sm:mt-px sm:py-2 w-full"
  >
    {label}
  </label>
  <div class="w-full h-48 border border-gray-400 relative rounded-md py-5 pr-5">
    <div {id} class="w-full h-40" />
  </div>
  <input
        value={query}
        {name}
        type="text"
        class="invisible w-0 h-0 p-0 m-0 border-0"
    />
</div>
